<template>
  <v-container id="contact-grid" grid-list-xl>
    <div class="row justify-content-center">
      <div class="col-md-12 col-lg-10">
        <div class="d-md-flex">
          <v-card elevation="10" class="mx-auto my-12 p-2" max-width="474">
            <v-card-title class="card-title justify-center">
              E-visa Cameroun
            </v-card-title>
            <v-spacer></v-spacer>
            <v-divider width="300" class="mx-auto"></v-divider>
            <v-img
              class="mx-auto"
              max-height="150"
              max-width="150"
              :src="shakhands"
            ></v-img>
            <v-card-text class="card-text">
              {{ $t("confirm_count_text") }}
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="white"
                text
                class="ma-2 pa-5 white--text warning mx-auto"
                @click="login"
              >
                {{ $t("login_btn") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import shakhands from "../../public/shakhands.png";
export default {
  name: "confirmation",
  components: {},
  data() {
    return {
      shakhands: shakhands,
    };
  },
  created() {
    this.$store.dispatch("setCurrentRoute", this.$route.name);

    this.$store.dispatch("clear_registered");
    this.$root.$i18n.locale = this.langLocal;
  },
  computed: {
    ...mapGetters(["current_route", "langLocal", "registered"]),
  },

  methods: {
    login() {
      this.$router.push("/login");
    },
  },
};
</script>
<style scoped>
#site-header {
  margin-top: 100px;
}
.card-title {
  color: rgb(53, 71, 99);
  font-size: 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
.card-text {
  line-height: 2.5;
  text-align: center;
  font-size: 16px;
}
</style>